var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpiredIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.19749 7.29462C5.09797 7.39413 4.96298 7.45007 4.82223 7.45007H2.60831C2.46756 7.45007 2.33257 7.39413 2.23304 7.29462L0.421067 5.48265C0.321539 5.38313 0.265625 5.24813 0.265625 5.10738V2.89347C0.265625 2.75271 0.321539 2.61772 0.421067 2.5182L2.23304 0.706224C2.33257 0.606696 2.46756 0.550781 2.60831 0.550781H4.82223C4.96298 0.550781 5.09797 0.606696 5.19749 0.706224L7.00946 2.5182C7.10897 2.61772 7.16491 2.75271 7.16491 2.89347V5.10738C7.16491 5.24813 7.10897 5.38313 7.00946 5.48265L5.19749 7.29462Z",
    stroke: "#C10000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.71484 2.4082V4.13302",
    stroke: "#C10000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.71471 5.59251C3.64143 5.59251 3.58203 5.5331 3.58203 5.45983C3.58203 5.38655 3.64143 5.32715 3.71471 5.32715",
    stroke: "#C10000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.71484 5.59251C3.78812 5.59251 3.84752 5.5331 3.84752 5.45983C3.84752 5.38655 3.78812 5.32715 3.71484 5.32715",
    stroke: "#C10000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpiredIcon);
export default __webpack_public_path__ + "static/media/expired_icon.106ca5cbe5e8c0497fdc23b09a150ca4.svg";
export { ForwardRef as ReactComponent };